module.exports = __webpack_public_path__ + "img/nutrition.ecbeb44b.jpg";